import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Tag = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10 7.5C10.8284 7.5 11.5 6.82843 11.5 6C11.5 5.17157 10.8284 4.5 10 4.5C9.17157 4.5 8.5 5.17157 8.5 6C8.5 6.82843 9.17157 7.5 10 7.5Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M14.5 7.37868V3C14.5 2.17157 13.8284 1.5 13 1.5H8.62132C8.2235 1.5 7.84197 1.65804 7.56066 1.93934L2.06066 7.43934C1.47488 8.02513 1.47488 8.97487 2.06066 9.56066L6.43934 13.9393C7.02513 14.5251 7.97487 14.5251 8.56066 13.9393L14.0607 8.43934C14.342 8.15804 14.5 7.7765 14.5 7.37868ZM13 3V7.37868L7.5 12.8787L3.12132 8.5L8.62132 3L13 3Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Tag;
